import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Popup from '@/components/Popup/index.jsx';

import imgBg from '@/assets/images/alert/bg.png';
import imgLabelOver from '@/assets/images/alert/labelOver.png';
import imgLabelThanksGet from '@/assets/images/alert/labelThanksGet.png';
import imglogin from '@/assets/images/alert/labelLogin.png';

import styles from './index.less';

const Alert=(props)=>{
  const {destory,label='注意',btnLabel='确定',text,className=''} = props;

  const imgLabel={
    '感谢认领':imgLabelThanksGet,
    '来晚啦':imgLabelOver,
    '登录':imglogin
  }
  const onOk=()=>{
    destory(true);
  }
  const onClose=()=>{
    destory(false);
  }
  return (
    <section className={styles.center}>
      <section className={`${styles.wrap} ${className}`} >
        <img className={styles.bg} src={imgBg} />
        {
          imgLabel[label]?<img className={styles.imgTitle} src={imgLabel[label]} />:<span className={styles.label}>{label}</span>
        }
        {
          typeof text == 'string'?(
            <span className={styles.text}>
              {text}
            </span>
          ):text
        }
        <div onClick={onOk} className={styles.btn}>{btnLabel}</div>
        <div onClick={onClose} className={styles.close}></div>
      </section>
    </section>
  )
}

const ShowAlert=(props)=>{
  const {text,label,btnLabel} = props;
  return new Promise(resolve=>{
    let popup = Popup(resolve);
    ReactDOM.render(
      <Alert label={label} btnLabel={btnLabel} destory={popup.destory} text={text} />,
      popup.dom
    );
  })
}

export default ShowAlert;